import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import sweetAlert, {
sweetStatusAlert,
sweetConfirmAlert
} from "../../../../components/common/SweetAlert.js";
import { tableDisplayFieldService } from "../../../../service/manage/h_tree/table_display_field.service.js";
import { tableLogService } from "../../../../service/manage/h_tree/table_log.service.js";
import Spinner from "react-bootstrap/Spinner";
import "../../../../components/admin/css/common.css";
import {
Table,
TableHead,
TableRow,
TableBody,
TableCell
} from "@mui/material";
import MaterialCustomTablePagination from "../../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import PageSpinner from "../../../../components/common/spinner/PageSpinner.js";
import ContentWrapper from "../../../../components/common/ContentWrapper.js";
import config from '../../../../helper/config.js';
import {customerConstants} from "../../../../helper/constants.js";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const getCustomerFeatureFlag = () => {
return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
case customerConstants.EXO_CUSTOMER1:
    break;
case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
    color: "var(--maincolor-cmc)",
    backgroundColor: "#E5F5FF",
    borderColor: "transparent",
    };
    addBtnStyle = {
    color: "#fff",
    backgroundColor: "var(--maincolor-cmc)",
    borderColor: "transparent",
    };
    break;
default:
    break;
}

export default class ManageTableDisplayField extends Component {
constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
        showModal: false,
        tableDisplayFields: [],
        tableLogs: [],
        tableColumns: [],
        tb_id: "",
        display_order: "",
        field_name: "",
        field_name_display: "",
        table_display_field_id: "",
        modalType: false,
        search_val: "",
        isLoading: true,
        isSpinnerLoading: false,
        isModified: false,
        limit: 10, // Set the desired limit
        offset: 0, // Set the desired offset
        search_term: "",
        sort_column: "table_display_field_id",
        sort_direction: "ASC",
        totalTableDisplayFields: 10,
        currentPage: 0,
        editVisibility: true,
        addVisibility: true,
        deleteVisibility: true,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);

    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllTableDisplayFieldsData, 2000);
}

resetFormFields = () => {
    this.setState({
        tb_id: "",
        field_name: "",
        field_name_display: "",
        display_order: "",
    });
};

componentDidMount() {
    this.getAllTableLogs();
    this.fetchAllTableDisplayFieldsData();
}

createValidationsInstance() {
    this.validator = new SimpleReactValidator();
}

getAllTableLogs = async() => {
    this.setState({ isLoading: true });
    await tableLogService.getAllTableLogs()
    .then((response) => {
        if (response.success) {
        this.setState({
            tableLogs: response.data.table_logs
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching Table Logs. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching Table Logs. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
        this.setState({ isLoading: false });
    });
}

getTableName(table_id) {
    if (table_id !== null) {
        const table = this.state.tableLogs?.find(
            (table) => table.table_id == parseInt(table_id)
        );
        return table?.table_name;
    }
    else {
        return "N/A";
    }
}

getAllTableColumns = async (table, stateKey = "tableColumns", loadingKey = "isLoading") => {
    this.setState({ [loadingKey]: true });
    try {
        const response = await tableDisplayFieldService.getAllTableColumns(table);
        if (response.success) {
            this.setState({
                [stateKey]: response.data.table_columns
            });
        } else {
            sweetStatusAlert(
                "Failed!",
                "Error fetching Table Columns. Please refresh the screen!",
                "error"
            );
        }
    } catch (error) {
        sweetStatusAlert(
            "Failed!",
            "Error fetching Table Columns. Please refresh the screen!",
            "error"
        );
    } finally {
        this.setState({ [loadingKey]: false });
    }
};

fetchAllTableDisplayFieldsData() {
    const { limit, offset, search_term, sort_column, sort_direction } = this.state;
    tableDisplayFieldService.getAll(limit, offset, search_term, sort_column, sort_direction)
    .then((response) => {
        if (response.success) {
        this.setState({
            tableDisplayFields: response.data.table_display_fields,
            totalTableDisplayFields: parseInt(response.data.total_count),
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching table display fields. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching table display fields. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
        this.setState({ isLoading: false, isSpinnerLoading: false });
    });
}

handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fetchAllTableDisplayFieldsData();
    }
    );
};

handleSortChange = (sort_column) => {
    // If the same column is clicked, toggle the sort direction
    const { sort_column: currentSortColumn, sort_direction } = this.state;
    const newSortDirection =
        currentSortColumn === sort_column && sort_direction === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
        {
            sort_column,
            sort_direction: newSortDirection,
            offset: 0, // Reset offset when changing sorting
            currentPage: 0,
            isLoading: true,
        },
        () => {
            this.fetchAllTableDisplayFieldsData();
        }
    );
};

handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage
    },
    () => {
        this.fetchAllTableDisplayFieldsData();
    }
    );
};

handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
    {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fetchAllTableDisplayFieldsData();
    }
    );
};

handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
    this.setState(
        {
        search_term,
        isLoading: true,
        offset: 0,
        currentPage: 0,
        searchError: false,
        },
        () => {
            this.debouncedHandleSearch();
        }
    );
    } else {
        this.setState({ search_term, searchError: true });
    }
};

toggleTableDisplayFieldModal = (modalType) => {
    this.modalType = modalType;
    this.setState((prevState) => ({
        showModal: !prevState.showModal,
    }));
};

toggleUpdateTableDisplayFieldModal = (table_display_field_id, tb_id, display_order, field_name, field_name_display, modalType) => {
    this.setState((prevState) => ({
        showModal: !prevState.showModal,
        table_display_field_id: table_display_field_id,
        tb_id: tb_id,
        display_order: display_order,
        field_name: field_name,
        field_name_display: field_name_display,
        modalType: modalType,
    }));
};

handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
};

handleChangeTable = async (event) => {
    const selectedTable = event.target.value;
    this.setState({
        tb_id: selectedTable,
        field_name: "",
        isTableLoading: true 
    });

    await this.getAllTableColumns(this.getTableName(selectedTable), "tableColumns", "isTableLoading");

    const fieldsForTable = this.state.tableDisplayFields.filter(
        (f) => f.tb_id === parseInt(selectedTable)
    );

    const maxDisplayOrder = fieldsForTable.length
        ? Math.max(...fieldsForTable.map((f) => f.display_order))
        : 0;

    this.setState({
        display_order: maxDisplayOrder + 1,
    });
};

handleChangeFieldName = (event) => {
    event.preventDefault();
    this.setState({ field_name: event.target.value });
};

handleSweetAlert = (modalType, modalVisibility) => {
    if (this.state.isModified) {
        sweetAlert().then((response) => {
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.modalType = false;
            this.setState(() => ({
            [modalVisibility]: response,
            isModified: false,
            }));
        });
    } else {
        this.validator.hideMessages();
        this.validator.purgeFields();
        this.resetFormFields();
        if (modalType) this.toggleTableDisplayFieldModal(false);
        else this.toggleUpdateTableDisplayFieldModal();
    }
};

//Handle Edit Submit
handleEditSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const tableDisplayFieldItem = {
            tb_id: this.state.tb_id,
            field_name: this.state.field_name,
            field_name_display: this.state.field_name_display,
            display_order: this.state.display_order,
        };
        const tableDisplayFieldId = this.state.table_display_field_id;

        tableDisplayFieldService.updateTableDisplayField(tableDisplayFieldItem, tableDisplayFieldId)
            .then((response) => {
            if (response.success) {
                this.setState({ isSpinnerLoading: false });
                this.toggleTableDisplayFieldModal();
                sweetStatusAlert(
                "Success!",
                "Table Display Field information updated successfully!",
                "success"
                );
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.fetchAllTableDisplayFieldsData();
            }else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((error) => {
            this.setState({ isSpinnerLoading: false });
            sweetStatusAlert(
                "Failed!",
                "Unable to update the table display field information",
                "error"
            );
            });
    }
};

//add new Table Display Field
handleSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const { tb_id, field_name, field_name_display, display_order } = this.state;
        const newTableDisplayFieldItem = {tb_id: tb_id, field_name: field_name, field_name_display: field_name_display, display_order: display_order};

        tableDisplayFieldService.addTableDisplayField(newTableDisplayFieldItem)
            .then((response) => {
            if (response.success) {
                sweetStatusAlert("Success!", response.message.success, "success");
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.toggleTableDisplayFieldModal(false);
                this.fetchAllTableDisplayFieldsData();
            } else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((err) => {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", "Unable to create new table display field", "error");
            });
    }
};

handleDeleteTableDisplayField = (id) => {
    sweetConfirmAlert().then(() => {
    this.setState({ isSpinnerLoading: true });
    tableDisplayFieldService.deleteTableDisplayField(id)
        .then((response) => {
        this.setState({ isSpinnerLoading: false });
        if (response.success) {
            sweetStatusAlert("Success!", response.message.success, "success");
            this.fetchAllTableDisplayFieldsData();
        } else {
            sweetStatusAlert("Failed!", response.message, "error");
        }
        })
        .catch((error) => {
            this.setState({ isSpinnerLoading: false });
            sweetStatusAlert("Oops!", "Error while deleting the table display field", "info");
        });
    });
};

render() {
    const {
        limit,
        tableDisplayFields,
        totalTableDisplayFields,
        isLoading,
        currentPage,
        isSpinnerLoading,
        editVisibility,
        addVisibility,
        deleteVisibility,
    } = this.state;
    return (
    <>
        <ContentWrapper>
        <div className="row justify-content-between align-items-center py-5 mb-3">
            <div className="col-md-6 col-6">
            <h3 className="text-nowrap">Manage Table Display Fields</h3>
            </div>
            <div>
            {addVisibility && (
                <Button
                    className="insert-btn"
                    variant="primary"
                    onClick={() => this.toggleTableDisplayFieldModal(true)}
                >
                    Add Table Display Field
                </Button>
            )}
            </div>
        </div>
        <div>
            <Form.Group controlId="exampleForm.ControlInput1" className="mb-2">
            <Form.Control
                type="text"
                placeholder="Search"
                onChange={this.handleSearch}
                isInvalid={this.state.searchError}
                // style={{ width: "18%" }}
                className="col-md-3 col-12"
            />
            {this.state.searchError && (
                <Form.Control.Feedback type="invalid">
                    Invalid input
                </Form.Control.Feedback>
            )}
            </Form.Group>
            {isSpinnerLoading && (
            <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isLoading ? (
            <div
                className="loading-container"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "75vw",
                    height: "90vh",
                }}
            >
                <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
                </Spinner>
            </div>
            ) : tableDisplayFields.length > 0 ? (
            <div style={{ width: "75vw", height: "90vh", overflow: "auto" }}>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("table_display_field_id")}
                    >
                        Table Display Field ID{" "}
                        {this.state.sort_column === "table_display_field_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("tb_id")}
                    >
                        Table ID{" "}
                        {this.state.sort_column === "tb_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("display_order")}
                    >
                        Display Order{" "}
                        {this.state.sort_column === "display_order" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("field_name")}
                    >
                        Table Field Name{" "}
                        {this.state.sort_column === "field_name" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("field_name_display")}
                    >
                        Table Display Field Name{" "}
                        {this.state.sort_column === "field_name_display" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    {(editVisibility || deleteVisibility) && (
                        <TableCell className="thead">Actions</TableCell>
                    )}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {tableDisplayFields.map((tableDisplayFieldItem) => (
                    <TableRow key={tableDisplayFieldItem.table_display_field_id}>
                        <TableCell className="tData">
                            {tableDisplayFieldItem.table_display_field_id}
                        </TableCell>
                        <TableCell className="tData">
                            {tableDisplayFieldItem.tb_id}
                        </TableCell>
                        <TableCell className="tData">
                            {tableDisplayFieldItem.display_order}
                        </TableCell>
                        <TableCell className="tData">
                            {tableDisplayFieldItem.field_name}
                        </TableCell>
                        <TableCell className="tData">
                            {tableDisplayFieldItem.field_name_display}
                        </TableCell>
                        {(editVisibility || deleteVisibility) && (
                        <TableCell>
                            <div className="btn-group">
                            {editVisibility && (
                                <Button
                                    onClick={() =>
                                        this.toggleUpdateTableDisplayFieldModal(
                                            tableDisplayFieldItem.table_display_field_id,
                                            tableDisplayFieldItem.tb_id,
                                            tableDisplayFieldItem.display_order,
                                            tableDisplayFieldItem.field_name,
                                            tableDisplayFieldItem.field_name_display,
                                            false
                                        )
                                    }
                                    className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                    title="Edit Details"
                                />
                            )}
                            {deleteVisibility && (
                                <Button
                                    onClick={() =>
                                        this.handleDeleteTableDisplayField(
                                            tableDisplayFieldItem.table_display_field_id
                                        )
                                    }
                                    className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                                    title="Delete"
                                />
                            )}
                            </div>
                        </TableCell>
                        )}
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
                <MaterialCustomTablePagination
                    totalCount = {totalTableDisplayFields}
                    currentPage = {currentPage}
                    limit = {limit}
                    handlePageChange = {this.handlePageChange}
                    handleRowsPerPageChange = {this.handleRowsPerPageChange}
                    handlePageOffsetChange = {this.handlePageOffsetChange}
                    offset = {this.state.offset}
                    rowsPerPageOptions={[5, 10, 20]}
                />
            </div>
            ) : (
            <div
                className="text-center mb-5 mt-10"
                style={{ height: "90vh" }}
            >
                <label>No Table Display Fields Available!</label>
            </div>
            )}
        </div>
        </ContentWrapper>

        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showModal}
            onHide={() => this.handleSweetAlert(this.modalType, "showModal")}
        >
        {this.modalType === true ? (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Create New Table Display Field</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Table*</Form.Label>
                    <Form.Select
                            id="tb_id"
                            value={this.state.tb_id || ""}
                            onChange={this.handleChangeTable}
                            className="form-control"
                        >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.tableLogs.map((option, index) => (
                                <option key={index} value={option.table_id}>
                                    {option.table_name}
                                </option>
                            ))}
                    </Form.Select>
                    {this.validator.message(
                        "tb_id",
                        this.state.tb_id,
                        "required",
                        {
                        className: "text-danger",
                        }
                    )}
                    </Form.Group>
                    <Form.Group 
                        as={Col} 
                        md="6" 
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Field Name*</Form.Label>
                    <Form.Select
                        id="field_name"
                        value={this.state.field_name || ""}
                        onChange={this.handleChangeFieldName}
                        className="form-control"
                        disabled={this.state.isTableLoading}
                    >
                        <option value="" disabled hidden style={{ color: "#6c757d" }}>
                            {this.state.isTableLoading ? "Loading..." : "Nothing Selected"}
                        </option>
                        {this.state.tableColumns && this.state.tableColumns.map((col, index) => (
                            <option key={index} value={col}>
                                {col}
                            </option>
                        ))}
                    </Form.Select>
                    {this.validator.message(
                        "field_name",
                        this.state.field_name,
                        "required",
                        { className: "text-danger" }
                    )}
                </Form.Group>
                </Row>
                <Row>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Display Order*</Form.Label>
                    <Form.Control
                        type="number"
                        name="display_order"
                        placeholder="Type display order here..."
                        value={this.state.display_order}
                        onChange={this.handleChange}
                        readOnly
                    />
                    {this.validator.message(
                        "display_order",
                        this.state.display_order,
                        "required",
                        {
                        className: "text-danger",
                        messages: {
                            required: "The display_order field is required.",
                        },
                        }
                    )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Field Display Name*</Form.Label>
                    <Form.Control
                        type="text"
                        name="field_name_display"
                        placeholder="Type name here..."
                        value={this.state.field_name_display}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "field_name_display",
                        this.state.field_name_display,
                        "required|max:60",
                        {
                        className: "text-danger",
                        messages: {
                            max: "The field display name should not be greater than 60 characters.",
                            required: "The field display name field is required.",
                        },
                        }
                    )}
                    </Form.Group>
                </Row>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleSubmit}
                >
                    Save changes
                </Button>
                <Button
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        ) : (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Update Table Display Field</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className="my-5">
                        <Form.Group
                            as={Col}
                            md="6"
                            controlId="exampleForm.ControlInput1"
                        >
                        <Form.Label>Select Table*</Form.Label>
                        <Form.Select
                                id="tb_id"
                                value={this.state.tb_id || ""}
                                onChange={this.handleChangeTable}
                                className="form-control"
                            >
                                <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                                {this.state.tableLogs.map((option, index) => (
                                    <option key={index} value={option.table_id}>
                                        {option.table_name}
                                    </option>
                                ))}
                        </Form.Select>
                        {this.validator.message(
                            "tb_id",
                            this.state.tb_id,
                            "required",
                            {
                            className: "text-danger",
                            }
                        )}
                        </Form.Group>
                        <Form.Group 
                            as={Col} 
                            md="6" 
                            controlId="exampleForm.ControlInput1"
                        >
                        <Form.Label>Select Field Name*</Form.Label>
                        <Form.Select
                            id="field_name"
                            value={this.state.field_name || ""}
                            onChange={this.handleChangeFieldName}
                            className="form-control"
                            disabled={this.state.isTableLoading}
                        >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>
                                {this.state.isTableLoading ? "Loading..." : "Nothing Selected"}
                            </option>
                            {this.state.tableColumns && this.state.tableColumns.map((col, index) => (
                                <option key={index} value={col}>
                                    {col}
                                </option>
                            ))}
                        </Form.Select>
                        {this.validator.message(
                            "field_name",
                            this.state.field_name,
                            "required",
                            { className: "text-danger" }
                        )}
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group
                            as={Col}
                            md="6"
                            controlId="exampleForm.ControlInput1"
                        >
                        <Form.Label>Display Order*</Form.Label>
                        <Form.Control
                            type="number"
                            name="display_order"
                            placeholder="Type display order here..."
                            value={this.state.display_order}
                            onChange={this.handleChange}
                            readOnly   
                        />
                        {this.validator.message(
                            "display_order",
                            this.state.display_order,
                            "required",
                            {
                            className: "text-danger",
                            messages: {
                                required: "The display_order field is required.",
                            },
                            }
                        )}
                        </Form.Group>
                        <Form.Group
                            as={Col}
                            md="6"
                            controlId="exampleForm.ControlInput1"
                        >
                        <Form.Label>Field Display Name*</Form.Label>
                        <Form.Control
                            type="text"
                            name="field_name_display"
                            placeholder="Type name here..."
                            value={this.state.field_name_display}
                            onChange={this.handleChange}
                        />
                        {this.validator.message(
                            "field_name_display",
                            this.state.field_name_display,
                            "required|max:60",
                            {
                            className: "text-danger",
                            messages: {
                                max: "The field display name should not be greater than 60 characters.",
                                required: "The field display name field is required.",
                            },
                            }
                        )}
                        </Form.Group>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="modal-btn"
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleEditSubmit}
                >
                    Save changes
                </Button>
                <Button
                    className="modal-btn"
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        )}
        </Modal>
    </>
    );
}
}
